import Immutable from 'immutable';
import { createSelector } from 'reselect';

const API_LOAD = 'settings/API_LOAD';
const API_LOAD_SUCCESS = 'settings/API_LOAD_SUCCESS';
const API_LOAD_FAIL = 'settings/API_LOAD_FAIL';
const USER_PREFERENCES_LOAD = 'settings/USER_PREFERENCES_LOAD';
const USER_PREFERENCES_LOAD_SUCCESS = 'settings/USER_PREFERENCES_LOAD_SUCCESS';
const USER_PREFERENCES_LOAD_FAIL = 'settings/USER_PREFERENCES_LOAD_FAIL';
const BASE_URL_SET = 'settings/BASE_URL_SET';

const initialState = Immutable.fromJS({
  baseUrl: null,
  isLoad: false,
  loadErr: null,
  settings: null,
  loading: false,
  loadingUserPreferences: false,
  userPreferencesError: false,
  userPreferences: {},
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case API_LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case API_LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('settings', action.settings);

    case API_LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('settings', null);

    case USER_PREFERENCES_LOAD:
      return state
        .set('loadingUserPreferences', true)
        .set('userPreferencesError', false);

    case USER_PREFERENCES_LOAD_SUCCESS:
      return state
        .set('loadingUserPreferences', false)
        .set('userPreferencesError', false)
        .set('userPreferences', action.payload);

    case USER_PREFERENCES_LOAD_FAIL:
      return state
      .set('loadingUserPreferences', false)
      .set('userPreferencesError', true);

    case BASE_URL_SET:
      return state
        .set('baseUrl', action.payload);

    default:
      return state;
  }
}

export const setBaseUrl = (baseUrl) => {
  return {
    type: BASE_URL_SET,
    payload: baseUrl,
  };
}

export const settings = () => async (dispatch, getState, api) => {
  dispatch({ type: API_LOAD });
  try {
    const res = await api.get('/account/api');
    if (res.message) {
      dispatch({ type: API_LOAD_FAIL, error: res.message });
      return;
    }
    dispatch({ type: API_LOAD_SUCCESS, settings: res });
  } catch (error) {
    dispatch({ type: API_LOAD_FAIL, error });
  }
};

export const generate = () => async (dispatch, getState, api) => {
  dispatch({ type: API_LOAD });
  try {
    const res = await api.put('/account/api');
    if (res.message) {
      dispatch({ type: API_LOAD_FAIL, error: res.message });
      return;
    }
    const settings = getState().get('settings').get('settings');
    settings.apikey = res.apikey;
    settings.id = res.id;

    dispatch({ type: API_LOAD_SUCCESS, settings: Object.assign({}, settings) });
  } catch (error) {
    dispatch({ type: API_LOAD_FAIL, error });
  }
};

export const getUserPreferences = (userId) => async (dispatch, getState, api) => {
  dispatch({ type: USER_PREFERENCES_LOAD });

  try {
    const response = await api.get(`/user/preferences/${userId}`);

    dispatch({ type: USER_PREFERENCES_LOAD_SUCCESS, payload: response });

    return response;
  } catch (error) {
    dispatch({ type: USER_PREFERENCES_LOAD_FAIL });
  }
};

export const updateUserPreferences = ({ videoSubmission }) => async (
  dispatch,
  getState,
  api
) => {
  try {
    const response = await api.put("/user/preferences", {
      data: { video_submission_email: videoSubmission },
    });

    dispatch({ type: USER_PREFERENCES_LOAD_SUCCESS, payload: response });

    return response;
  } catch (error) {
    dispatch({ type: USER_PREFERENCES_LOAD_FAIL });
  }
};

// Selectors
export const getSettingsState = createSelector(
  state => state.get('settings'),
  settingsNode => settingsNode,
);

export const getBaseUrl = createSelector(
  getSettingsState,
  settings => settings.get('baseUrl'),
);



// WEBPACK FOOTER //
// ./src/redux/modules/settings.js